import React, { useEffect, useState } from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'

const Editor = React.forwardRef((props, editorRef) => {
    const {
        initialValue
    } = props
    const formattedInitialValue = initialValue.replace(/\n/g, "<br>");
    const [value, setValue] = useState(formattedInitialValue);

    const COLORS = ['#B80000', '#DB3E00', '#FCCB00', '#008B02', '#006B76', '#1273DE', '#004DCF', '#5300EB', '#EB9694', '#D4C4FB'];

    const modules = {
        toolbar: [
            [{ 'header': [1, 2, false] }],
            ['bold', 'italic', 'underline', { 'color': COLORS }],
            [{'list': 'ordered'}, {'list': 'bullet'}],
            ['clean']
        ],
    };

    const formats = [
        'header',
        'bold', 'italic', 'underline', 'color',
        'list', 'bullet',
    ];

    useEffect(() => {
        if (typeof(editorRef.current.focus) !== 'function') return;
        editorRef.current.focus()
    })

    return (
        <ReactQuill
            ref={editorRef}
            theme='snow'
            modules={modules}
            formats={formats}
            value={value}
            onChange={setValue}
        />
    );
})

export default Editor;
